import React, { useContext } from 'react'
import Buttons from '../../buttons/buttons'
import { Context } from '../../context/provider'
import styles from '../../tagRenewalHome/tagRenewalHome.module.scss'
import { navigate } from 'gatsby'

export default function BoatRenewalHome() {
  const context = useContext(Context)

  function handleClick() {
    const setCurrent = context?.setCurrent

    setCurrent(0)
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <img className={styles.plate} src="/plate.png" alt="" />
        <h1>Muscogee (Creek) Nation Boat Renewal</h1>
        <h2>Before we get started, please ensure you have these items:</h2>
        <ul>
          <li>Boat HIN or serial #</li>
          <li>Boat year</li>
          <li>Roll number</li>
        </ul>
        <Buttons {...{
          handleBack: () => navigate('/'),
          handleNext: handleClick,
          nextLabel: `Let's get started`,
          backLabel: 'BACK'
        }} />
      </div>
    </section>
  )
}